import { render, staticRenderFns } from "./ConfirmSuccess.pug?vue&type=template&id=1ecd4a0c&lang=pug&"
import script from "./ConfirmSuccess.vue?vue&type=script&lang=js&"
export * from "./ConfirmSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports